import { useState, useEffect } from 'react';

import { useNavigate } from 'react-router-dom'; // Import the useNavigate hook

import AppointmentsService from '../../../services/AppointmentsService';
import Container from '../../blocks/container';

/**
 * Component to display a table of unsent appointments for a technician.
 * It fetches the appointments from the service and displays them in a table format.
 * If there are no appointments, it returns null.
 * @returns {JSX.Element|null} The rendered component or null if no appointments are found.
 */
const AppointmentsUnsetTable = ({}) => {

    const navigate = useNavigate(); // Initialize the navigate hook

    // State to hold the technician's appointments
    const [appointments, setAppointments] = useState([]);

    useEffect(() => {
        (async () => {
            try {
                const list = await AppointmentsService.getAppointmentsUnsendByTechnician();
                setAppointments(list);
            } catch (err) {
                console.error('Erreur lors du chargement des interventions :', err);
            }
        })();
    }, []);

    /**
     * Handles the click event on a folder number.
     * This function can be expanded to include logic for opening a modal or navigating to a folder
     * @param {number} folderNumber - The folder number that was clicked.
     */
    const handleFolderClick = (folderNumber) => {
        navigate(`/folders/${folderNumber}/overview/`); // Navigate to the folder page
    };

    // State to manage the modal visibility
    if (!appointments || appointments.length === 0) {
        return null;
    }

    // Get the last appointment from the list
    return (
        <Container
            className="appointments-unset-container"
            title="Interventions non transmises"
            titleBackground='var(--primary-color)'
        >
            <table className='appointments-unset-table'>
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Client</th>
                        <th>Numpéros de dossier</th>
                    </tr>
                </thead>
                <tbody>
                    {appointments.map((appt) => (
                        <tr key={appt.id}>
                            <td>
                                {new Date(appt.appointment_date)
                                    .toLocaleString('fr-FR', {
                                    day:   '2-digit',
                                    month: '2-digit',
                                    year:  'numeric',
                                    hour:   '2-digit',
                                    minute: '2-digit'
                                    })
                                }
                            </td>
                            <td>{appt.client_name}</td>
                            <td className='folder-number' onClick={() => handleFolderClick(appt.folder_number)}>
                                {appt.folder_number}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </Container>
    );
};

export default AppointmentsUnsetTable;